import {
  RollbarErrorHandler,
  RollbarService,
  rollbarFactory,
} from '../../services/rollbar-handler-service'

import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgModule, ErrorHandler, enableProdMode } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { environment } from '../../environments/environment'

// Modules
import { AppRoutingModule } from './app-routing.module'
import { PaginationModule } from '../pagination/pagination.module'

// Components, Actions
import { MainApp } from './app.component'

// Vendors
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { PopoverModule } from 'ngx-bootstrap/popover'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { TabsModule } from 'ngx-bootstrap/tabs'
import { AccordionModule } from 'ngx-bootstrap/accordion'
import { CarouselModule } from 'ngx-bootstrap/carousel'
import { AlertModule } from 'ngx-bootstrap/alert'

import { DeviceDetectorModule } from 'ngx-device-detector'
import { TagInputModule } from 'ngx-chips'

// ===========================================================================
// ==========                       Modules                       ============
// ===========================================================================

import { LayoutModule } from '../layout/layout.module'

// ===========================================================================
// ==========                      Components                     ============
// ===========================================================================

// Modals
import { ModalModule } from '../modal/modal.module'
import { ConfirmBlockModal } from '../../components/modals/confirm-block-modal/confirm-block-modal.component'
import { AcceptTopicModal } from '../../components/modals/accept-topic-modal.component'
import { TosModal } from '../../components/modals/tos-modal.component'

// Other Components
import { NavBarModule } from '../nav-bar/nav-bar.module'
import { KeywordPanelModule } from '../keyword-panel/keyword-panel.module'
import { PaymentInfoFormModule } from '../payment-info-form/payment-info-form.module'
import { WriterAvatarModule } from '../writer-avatar/writer-avatar.module'
import { RedDotModule } from "../red-dot/red-dot.module"

import { AccountActivationSummary } from '../../components/account-activation-summary.component'
import { NcNav } from '../../components/nc-nav.component'
import { NcNavV1 } from '../../components/nc-nav-v1.component'
import { ProposedTopicBox } from '../../components/proposed-topic-box.component'
import { PostTabs } from '../../components/post-tabs/post-tabs.component'
import { SubscriptionHeader } from '../../components/subscription-header.component'
import { WriterAccountPostsList } from 'components/writer-account-posts-list/writer-account-posts-list.component'
import { WriterCustomerPostsList } from 'components/writer-customer-posts-list/writer-customer-posts-list.component'
import { WriterProfile } from 'components/writer-profile.component'
import { CustomerCredits } from '../../components/customer-credits.component'

// ===========================================================================
// ==========                        Pages                        ============
// ===========================================================================

import { AccountSignupClientsHomePage } from '../../pages/new-account/account-signup-clients-home-page'
import { AccountSignupHomePage } from 'src/pages/new-account/account-signup-home-page'
import { ClientConfigurationPage } from '../../pages/new-account/client-configuration-page'
import { ClientNamePage } from '../../pages/new-account/client-name-page'
import { NewAccountPage } from '../../pages/new-account/new-account-page'

// About
import { AboutNav } from '../../pages/new-customer/about/about-nav'
import { AudienceAndVoicePage } from '../../pages/new-customer/about/audience-and-voice-page'
import { IndustryPage } from '../../pages/new-customer/about/industry-page'
import { OnlinePresencePage } from '../../pages/new-customer/about/online-presence-page'
import { OtherInfoPage } from '../../pages/new-customer/about/other-info-page'
import { TonePage } from '../../pages/new-customer/about/tone-page'

import { NcPaymentPage } from '../../pages/new-customer/nc-payment-page'
import { NcPlanPage } from '../../pages/new-customer/nc-plan-page'
import { NcMultipassPlanPage } from '../../pages/new-customer/nc-multipass-plan-page'
import { NcRegistrationPage } from '../../pages/new-customer/nc-registration-page'
import { NcTopicsPage } from '../../pages/new-customer/nc-topics-page'
import { NewCustomerPage } from '../../pages/new-customer/new-customer-page'
import { PricingPage } from '../../pages/pricing-page'
import { BenefitsCarousel } from '../../components/benefits-carousel.component'

// New Customer Variant
import { AboutNavV1 } from '../../pages/new-customer-v1/about/about-nav'
import { AudienceAndVoicePageV1 } from '../../pages/new-customer-v1/about/audience-and-voice-page'
import { IndustryPageV1 } from '../../pages/new-customer-v1/about/industry-page'
import { OnlinePresencePageV1 } from '../../pages/new-customer-v1/about/online-presence-page'
import { OtherInfoPageV1 } from '../../pages/new-customer-v1/about/other-info-page'
import { TonePageV1 } from '../../pages/new-customer-v1/about/tone-page'

import { NcPaymentPageV1 } from '../../pages/new-customer-v1/nc-payment-page'
import { NcPlanPageV1 } from '../../pages/new-customer-v1/nc-plan-page'
import { NcMultipassPlanPageV1 } from '../../pages/new-customer-v1/nc-multipass-plan-page'
import { NcRegistrationPageV1 } from '../../pages/new-customer-v1/nc-registration-page'
import { NcTopicsPageV1 } from '../../pages/new-customer-v1/nc-topics-page'
import { NewCustomerPageV1 } from '../../pages/new-customer-v1/new-customer-page'

// Other Pages
import { DashboardPage } from '../../pages/dashboard-page/dashboard-page.component'
import { PaymentInfoPage } from '../../pages/payment-info-page'
import { CustomerWriterProfilePage } from '../../pages/customer-writer-profile-page'
import { PlanPage } from '../../pages/plan-page'
import { MultipassPlanPage } from '../../pages/multipass-plan-page'
import { PublicWriterProfilePage } from '../../pages/public-writer-profile-page'
import { ProposedTopicsPage } from '../../pages/proposed-topics-page'


// GraphQL
import { ApolloModule} from 'apollo-angular'
import { HttpClientModule } from '@angular/common/http'
import { HttpLinkModule } from 'apollo-angular-link-http'
import { GraphqlService } from '../../services/graphql.service'

// tinymce
import { EditorModule } from '@tinymce/tinymce-angular'
import { SharedModule } from '../shared/shared.module'
import { PlanFormModule } from '../plan-form/plan-form.module'
import { MultipassPlanModule } from '../multipass-plan/multipass-plan.module'
import { PostBoxModule } from '../post-box/post-box.module'

import { PipesModule } from '../../pipes/pipes.module'
import { TypeaheadModule } from 'ngx-bootstrap/typeahead'
import { MaterialModule } from '../material/material.module'
import { CustomersNavComponentModule } from '../customers-nav/customers-nav.module'
import { EditspaceService } from 'src/services/editspace.service'
import { KeywordsModule } from '../keywords/keywords.module'

import { LocalStorage } from 'src/services/local-storage.service'
import { PersistentDropdownModule } from '../persistent-dropdown/persistent-dropdown.module'
import { PersistentDropdownService } from '../persistent-dropdown/persistent-dropdown.service'

if (environment.production) enableProdMode()

@NgModule({
    // Entry point components, directives, pipes
    declarations: [
      MainApp,
      ConfirmBlockModal,
      AcceptTopicModal,
      TosModal,
      AccountActivationSummary,
      NcNav,
      NcNavV1,
      ProposedTopicBox,
      PostTabs,
      SubscriptionHeader,
      WriterAccountPostsList,
      WriterCustomerPostsList,
      WriterProfile,
      AccountSignupClientsHomePage,
      AccountSignupHomePage,
      ClientConfigurationPage,
      ClientNamePage,
      NewAccountPage,
      AboutNav,
      AudienceAndVoicePage,
      IndustryPage,
      OnlinePresencePage,
      OtherInfoPage,
      TonePage,
      NcPaymentPage,
      NcPlanPage,
      NcMultipassPlanPage,
      NcRegistrationPage,
      NcTopicsPage,
      NewCustomerPage,
      PaymentInfoPage,
      CustomerWriterProfilePage,
      DashboardPage,
      ProposedTopicsPage,
      PlanPage,
      MultipassPlanPage,
      PublicWriterProfilePage,
      PricingPage,
      BenefitsCarousel,
      CustomerCredits,
      AboutNavV1,
      AudienceAndVoicePageV1,
      IndustryPageV1,
      OnlinePresencePageV1,
      OtherInfoPageV1,
      TonePageV1,
      NcPaymentPageV1,
      NcPlanPageV1,
      NcMultipassPlanPageV1,
      NcRegistrationPageV1,
      NcTopicsPageV1,
      NewCustomerPageV1,
    ],

    imports: [
      NavBarModule,
      KeywordPanelModule,
      PaymentInfoFormModule,
      WriterAvatarModule,
      PostBoxModule,
      MaterialModule,
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      BrowserModule,
      BrowserAnimationsModule,
      PaginationModule,
      BsDropdownModule.forRoot(),
      PopoverModule.forRoot(),
      TooltipModule.forRoot(),
      TabsModule.forRoot(),
      AccordionModule.forRoot(),
      CarouselModule.forRoot(),
      AlertModule.forRoot(),
      DeviceDetectorModule.forRoot(),
      TypeaheadModule.forRoot(),
      TagInputModule,
      ModalModule,
      LayoutModule,
      HttpClientModule,
      HttpLinkModule,
      ApolloModule,
      EditorModule,
      SharedModule,
      PlanFormModule,
      MultipassPlanModule,
      PipesModule,
      CustomersNavComponentModule,
      RedDotModule,
      KeywordsModule,
      PersistentDropdownModule,
    ],
    providers: [
      { provide: ErrorHandler, useClass: RollbarErrorHandler },
      { provide: RollbarService, useFactory: rollbarFactory },
      EditspaceService,
      { provide: Storage, useClass: LocalStorage },
      PersistentDropdownService
    ],
    bootstrap: [
      MainApp,
    ],
    exports: [
      SubscriptionHeader
    ]

})
export class AppModule {
  constructor(graphqlService: GraphqlService) {
    graphqlService.create()
  }
}
